import axios from 'axios';

import { ApiResponse } from '../model';
import type { Hospital } from '../model';

interface DoctorLoginParams {
  password: string;
  username: string;
}

export interface AuthResponse {
  userId: number;
  /** false — нужно показать форму заполнения профиля (после validate_code / register) */
  isProfileCompleted?: boolean;
  /** false — нужно согласие с политикой ПДн (после validate_code / register) */
  legal_agreement_accepted?: boolean;
  legal_agreement_version?: number | null;
}

interface HospitalsResponse {
  items: Hospital[];
  status: string;
}

interface LeedPatientRegistration {
  surname: string;
  name: string;
  midname: string;
  username: string;
  password: string;
}

export interface PatientRegistration {
  name: string;
  midname: string;
  surname: string;
  gender_id: number;
  birthdate: string;
  username: string;
  email: string;
  password: string;
  hospital_id: number;
  code?: string;
}

export class AuthApi {
  /** Шаг 1: логин доктора (логин + пароль). При успехе сессия создаётся, далее нужен выбор клиники. */
  static async authorizeDoctor(
    params: DoctorLoginParams,
  ): Promise<ApiResponse<AuthResponse>> {
    const { data } = await axios.post<ApiResponse<AuthResponse>>(
      '/api/v1/auth/doctor/login',
      params,
    );

    return data;
  }

  /** Список клиник, доступных залогиненному доктору (после успешного authorizeDoctor). */
  static async getDoctorHospitals(): Promise<Hospital[]> {
    const { data } = await axios.get<HospitalsResponse>(
      '/api/v1/private/hospitals/',
    );
    return data.items ?? [];
  }

  /** Шаг 2: выбор клиники. Завершает вход в ЛК доктора. */
  static async selectDoctorHospital(hospital_id: string): Promise<void> {
    await axios.post('/api/v1/auth/doctor/hospital', { hospital_id });
  }

  static async sendEmail(
    email: string,
    hospital_id: string,
  ): Promise<ApiResponse> {
    const { data } = await axios.post<ApiResponse>(
      '/api/v1/client/send_email',
      { email, hospital_id },
    );
    return data;
  }

  static async registerClient(
    params: PatientRegistration,
  ): Promise<ApiResponse<AuthResponse>> {
    const { data } = await axios.post<ApiResponse<AuthResponse>>(
      '/api/v1/client/register',
      params,
    );

    return data;
  }

  static async sendCode(phone: string): Promise<ApiResponse> {
    const { data } = await axios.post<ApiResponse>('/api/v1/auth/send_code', {
      phone,
    });

    return data;
  }

  static async validateCode(
    phone: string,
    code: string,
  ): Promise<ApiResponse<AuthResponse>> {
    const { data } = await axios.post<ApiResponse<AuthResponse>>(
      '/api/v1/auth/validate_code',
      { code, phone },
    );

    return data;
  }

  static async logOut(): Promise<ApiResponse> {
    const { data } = await axios.post<ApiResponse>('/api/v1/auth/logout');

    return data;
  }

  static async checkAuth(): Promise<ApiResponse> {
    const { data } = await axios.get<ApiResponse>('/api/v1/auth/doctor/check');

    return data;
  }

  static async checkClientAuth(): Promise<ApiResponse> {
    const { data } = await axios.get<ApiResponse>('/api/v1/client/people');

    return data;
  }

  static async leadClientRegister(
    form_data: LeedPatientRegistration,
  ): Promise<ApiResponse<AuthResponse>> {
    const { data } = await axios.post<ApiResponse<AuthResponse>>(
      '/api/v1/landing/register',
      form_data,
    );

    return data;
  }
}
